module.exports = __webpack_public_path__ + "static/media/MADRE_PERLA.32091ccc.jpg";